import React from "react";

// styles
import useStyles from "./styles";

// components
import {Typography} from "../Wrappers/Wrappers";
import {Grid} from "@material-ui/core";


function LastUpdate(props) {
    const classes = useStyles();

    return (
        <div className={classes.pageTitleContainer}>
            <Grid container justify="space-between"
                                alignItems="center">
                <Grid item xs={12} md={9}>
                    <Typography className={classes.typo} variant="p" size="sm">
                        Zuletzt aktualisiert am: {props.lastUpdateDate}
                    </Typography>
                </Grid>
            </Grid>
        </div>
    );
}




export default LastUpdate